import { Injectable, computed, signal } from '@angular/core';

/**
 * Shared UI state for the application shell.
 * Phase 1 keeps it in the app folder; Phase 2 will migrate this to `libs/shared/ui-layout`.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly _sidebarCollapsed = signal<boolean>(false);

  readonly sidebarCollapsed = this._sidebarCollapsed.asReadonly();
  readonly sidebarWidthClass = computed(() => (this._sidebarCollapsed() ? 'w-16' : 'w-64'));

  toggleSidebar(): void {
    this._sidebarCollapsed.update((collapsed) => !collapsed);
  }

  setSidebar(collapsed: boolean): void {
    this._sidebarCollapsed.set(collapsed);
  }
}
